import React from "react";
import Cards  from "../modules/Cards/Cards";
export default function CardsPage() {
  return <Cards />;
}
